import { LineChartLine } from "./line-chart.component";

export function getDateRange(dateRange: [Date, Date]): { start: number; end: number; step: number } {
  const [startDate, endDate] = dateRange;
  const deltaMinutes = Math.round((endDate.getTime() - startDate.getTime()) / 1000 / 60);
  const step = (Object.entries({ 2880: 300, 20160: 3600, 86400: 14400, 259200: 28800 }) as [string, number][]).reduce(
    (acc, [k, v]) => (deltaMinutes >= +k ? v : acc),
    60,
  );
  const snap = (d: Date) => {
    const t = Math.round(d.getTime() / 1000);
    return t - (t % step);
  };
  return { start: snap(startDate), end: snap(endDate), step };
}

/**
 * Converts raw API data points to a {@link LineChartLine}.
 *
 * Each entry in `secondsPoints` must have at least 2 elements: a timestamp in seconds (first) and
 * a value (second); the timestamp is converted to milliseconds as Highcharts expects.
 *
 * A null value means no measurement for that bucket; it stays null so Highcharts renders a gap.
 *
 * `multiplier` scales the value, e.g. to negate it so a series draws downwards.
 */
export function toLineChartLine(secondsPoints: (number | null)[][], multiplier = 1): LineChartLine {
  return secondsPoints.map(([t, v]) => [(t as number) * 1000, v == null ? null : v * multiplier]);
}
